export default "__VITE_ASSET__DJjqO29c__"